import React from 'react';
import HomeTopicOne from './HomeTopic-One';
import HomeTopicTwo from './HomeTopic-Two';
import HomeTopicThree from './HomeTopic-Three';
import HomeTopicFour from './HomeTopic-Four';

const HomePage = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <HomeTopicOne />
      <HomeTopicTwo />
      <HomeTopicThree />
      <HomeTopicFour />
    </div>
  );
};

export default HomePage;
